interface HeroSectionProps {
  username: string;
}

export default function HeroSection({ username }: HeroSectionProps) {
  const scrollToNext = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-20 sm:pt-28 pb-16 sm:pb-20 relative">
      <div className="max-w-6xl mx-auto text-center w-full">
        {/* Main Title */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-6 leading-tight animate-fadeInUp">
          <span className="bg-gradient-to-r from-white via-[#00d4ff] to-[#a855f7] bg-clip-text text-transparent">
            Roblox Итоги 2025
          </span>
          <br />
          <span className="text-white">для </span>
          <span 
            className="text-white relative inline-block break-words"
            style={{ 
              textShadow: '0 0 30px rgba(0,212,255,0.8), 0 0 60px rgba(0,212,255,0.4)' 
            }}
          >
            {username}
          </span>
        </h1>

        {/* Subtitle */}
        <div className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/80 mb-12 sm:mb-16 space-y-1 sm:space-y-2 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
          <p>Ваш год.</p>
          <p>Ваши рекорды.</p>
          <p>Ваш подарок.</p>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={scrollToNext}
          className="inline-flex flex-col items-center gap-2 text-[#00d4ff] hover:text-[#a855f7] transition-colors duration-300 animate-bounce cursor-pointer"
          style={{ animationDelay: '0.4s' }}
        >
          <span className="text-xs sm:text-sm font-medium uppercase tracking-wider">Прокрутить вниз</span>
          <i className="ri-arrow-down-line text-2xl sm:text-3xl"></i>
        </button>
      </div>

      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] sm:w-[400px] md:w-[600px] h-[300px] sm:h-[400px] md:h-[600px] bg-[#00d4ff]/10 rounded-full blur-[120px] pointer-events-none" />
    </section>
  );
}
